import { motion } from "framer-motion";

export const HOST = window.location.hostname;

// Cornici e pezzi comuni dei disegni animati della guida all'installazione.
export const Phone = ({ os, children }) => (
  <div className="relative mx-auto w-[196px] h-[392px] rounded-[2.3rem] bg-slate-900 p-[8px] shadow-2xl shadow-slate-900/30" data-testid="install-guide-phone">
    <div className="relative w-full h-full rounded-[1.85rem] overflow-hidden bg-white text-slate-900">
      <div className="absolute inset-x-0 top-0 h-6 px-4 flex items-center justify-between text-[9px] font-semibold z-30">
        <span>9:41</span><span className="flex gap-0.5"><i className="w-3 h-1.5 rounded-sm bg-slate-900" /><i className="w-1.5 h-1.5 rounded-full bg-slate-900" /></span>
      </div>
      {os === "ios"
        ? <div className="absolute top-1.5 left-1/2 -translate-x-1/2 w-16 h-[18px] rounded-full bg-slate-900 z-30" />
        : <div className="absolute top-2 left-1/2 -translate-x-1/2 w-2.5 h-2.5 rounded-full bg-slate-900 z-30" />}
      {children}
    </div>
  </div>
);

export const Laptop = ({ children }) => (
  <div className="mx-auto w-[320px]" data-testid="install-guide-laptop">
    <div className="rounded-t-xl bg-slate-900 p-[7px] pb-[9px]">
      <div className="relative h-[190px] rounded-md overflow-hidden bg-slate-100 text-slate-900">{children}</div>
    </div>
    <div className="h-3 rounded-b-xl bg-slate-300 mx-[-14px]" />
  </div>
);

export const Tap = ({ className = "" }) => (
  <span className={`pointer-events-none absolute z-40 w-4 h-4 ${className}`}>
    <motion.span className="absolute inset-0 rounded-full bg-primary/50" animate={{ scale: [1, 2.4], opacity: [0.8, 0] }} transition={{ duration: 1.1, repeat: Infinity }} />
    <span className="absolute inset-0 rounded-full bg-primary border-2 border-white shadow-md" />
  </span>
);

// Evidenzia il pulsante da toccare (anello pulsante + "dito").
export const Hot = ({ children, className = "" }) => (
  <motion.span className={`relative inline-flex items-center justify-center rounded-lg ring-2 ring-primary ring-offset-1 ${className}`}
    animate={{ scale: [1, 1.06, 1] }} transition={{ duration: 1.1, repeat: Infinity }}>
    {children}
    <Tap className="-bottom-1.5 -right-1.5" />
  </motion.span>
);

export const FakePage = ({ dim = false }) => (
  <div className={`absolute inset-0 pt-8 px-4 space-y-2.5 transition-opacity ${dim ? "opacity-40" : ""}`}>
    <div className="flex items-center gap-2"><img src="/icon-192.png" alt="" className="w-7 h-7 rounded-lg" /><b className="text-[11px]">K Gestionale</b></div>
    <div className="h-14 rounded-xl bg-gradient-to-br from-slate-800 to-slate-600" />
    <div className="h-2 rounded bg-slate-200 w-4/5" /><div className="h-2 rounded bg-slate-200 w-3/5" />
    <div className="grid grid-cols-2 gap-1.5 pt-1">{[0, 1, 2, 3].map((i) => <div key={i} className="h-9 rounded-lg bg-orange-100" />)}</div>
  </div>
);

const GREY = ["bg-sky-300", "bg-emerald-300", "bg-amber-300", "bg-rose-300", "bg-violet-300", "bg-slate-300", "bg-lime-300"];

export const HomeScreen = ({ dock = true }) => (
  <div className="absolute inset-0 bg-gradient-to-b from-sky-500 to-indigo-600 pt-10 px-4">
    <div className="grid grid-cols-4 gap-x-2.5 gap-y-3">
      {GREY.map((c) => <div key={c} className={`aspect-square rounded-xl ${c} opacity-80`} />)}
      <motion.div className="flex flex-col items-center gap-0.5" initial={{ scale: 0, opacity: 0 }} animate={{ scale: 1, opacity: 1 }}
        transition={{ type: "spring", stiffness: 260, damping: 14, delay: 0.3 }} data-testid="install-guide-home-icon">
        <span className="relative"><img src="/icon-192.png" alt="K Gestionale" className="aspect-square w-full rounded-xl ring-2 ring-white" /><Tap className="-bottom-1 -right-1" /></span>
        <span className="text-[7px] text-white font-semibold leading-none">K Gestionale</span>
      </motion.div>
    </div>
    {dock && <div className="absolute bottom-3 inset-x-3 h-12 rounded-2xl bg-white/25 backdrop-blur" />}
  </div>
);

export const Sheet = ({ children, className = "" }) => (
  <motion.div className={`absolute inset-x-0 bottom-0 z-20 bg-slate-100 rounded-t-2xl shadow-2xl ${className}`}
    initial={{ y: "100%" }} animate={{ y: 0 }} transition={{ type: "spring", stiffness: 220, damping: 26, delay: 0.15 }}>
    {children}
  </motion.div>
);
